module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Purple-Monsters-Joyful-Scene-640.e9a54690.jpg";